import Cookies from 'js-cookie';

export const CONSENT_KEY = 'cookiesPolicyAccepted';

// Deliberately short, per BWSM-109. This sits under the 7 day cap Safari's ITP
// applies to script-written cookies, so the cookie is a reliable single source
// of truth and needs no localStorage mirror to survive.
const CONSENT_EXPIRY_DAYS = 2;

// Scope to the registrable domain so consent given on www carries over to the
// apex domain and any other bankvic.com.au subdomain. Left undefined (host-only)
// on localhost and preview builds, where a .bankvic.com.au cookie would be rejected.
const consentCookieDomain = (): string | undefined =>
  typeof window !== 'undefined' && window.location.hostname.endsWith('bankvic.com.au')
    ? '.bankvic.com.au'
    : undefined;

export const hasCookieConsent = (): boolean => {
  if (typeof window === 'undefined') return false;
  return Cookies.get(CONSENT_KEY) === 'true';
};

export const grantCookieConsent = () => {
  if (typeof window === 'undefined') return;

  Cookies.set(CONSENT_KEY, 'true', {
    expires: CONSENT_EXPIRY_DAYS,
    path: '/',
    domain: consentCookieDomain(),
    sameSite: 'lax',
    secure: window.location.protocol === 'https:',
  });
};
